var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20.0957C9.11667 20.0957 7.81667 19.833 6.6 19.3077C5.38333 18.7824 4.325 18.07 3.425 17.1707C2.525 16.2707 1.81267 15.2124 1.288 13.9957C0.763333 12.779 0.500667 11.479 0.5 10.0957C0.5 8.71237 0.762667 7.41237 1.288 6.1957C1.81333 4.97904 2.52567 3.9207 3.425 3.0207C4.325 2.1207 5.38333 1.40837 6.6 0.883703C7.81667 0.359037 9.11667 0.0963698 10.5 0.0957031C11.8833 0.0957031 13.1833 0.35837 14.4 0.883703C15.6167 1.40904 16.675 2.12137 17.575 3.0207C18.475 3.9207 19.1877 4.97904 19.713 6.1957C20.2383 7.41237 20.5007 8.71237 20.5 10.0957C20.5 11.479 20.2373 12.779 19.712 13.9957C19.1867 15.2124 18.4743 16.2707 17.575 17.1707C16.675 18.0707 15.6167 18.7834 14.4 19.3087C13.1833 19.834 11.8833 20.0964 10.5 20.0957ZM10.5 18.0957C12.7167 18.0957 14.6043 17.3167 16.163 15.7587C17.7217 14.2007 18.5007 12.313 18.5 10.0957C18.5 7.87904 17.721 5.99137 16.163 4.4327C14.605 2.87404 12.7173 2.09504 10.5 2.0957C8.28333 2.0957 6.39567 2.8747 4.837 4.4327C3.27833 5.9907 2.49933 7.87837 2.5 10.0957C2.5 12.3124 3.279 14.2 4.837 15.7587C6.395 17.3174 8.28267 18.0964 10.5 18.0957Z",
    fill: "#00C851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 11.0481L9.56365 14.0957L15.1904 6.0957",
    stroke: "#00C040",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickCircle);
export default __webpack_public_path__ + "static/media/green-tick-circle.4ecf242ea8a564abbf28f29895e1791b.svg";
export { ForwardRef as ReactComponent };